import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  /*摄影任务 */
  //摄影订单列表
  orderList: (data) => apiAxios('post', baseURL + '/photo.orderList', data),
  //摄影订单-更新备注预设
  updateRemarkRemark: (data) => apiAxios('post', baseURL + '/photo.updateRemarkRe', data),
  //摄影任务-列表
  jobList: (data) => apiAxios('post', baseURL + '/photo.jobList', data),
  //摄影任务-新增
  storeJob: (data) => apiAxios('post', baseURL + '/photo.storeJob', data),
  //摄影订单-删除
  deleteOrder: (data) => apiAxios('post', baseURL + '/photo.deleteOrder', data),
  //摄影任务-删除
  deleteJob: (data) => apiAxios('post', baseURL + '/photo.deleteJob', data),
  //摄影任务-完成
  completeJob: (data) => apiAxios('post', baseURL + '/photo.completeJob', data),

}